import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { notificationAPI } from '../services/api';
import { toggleTheme } from '../utils/theme';
import { getDashboardPath } from '../utils/roleUtils';

export default function TopBar({ user, onLogout, onOpenSearch }) {
  const [theme, setTheme] = useState(() => document.documentElement.getAttribute('data-theme') || 'light');
  const [notifOpen, setNotifOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [notifs, setNotifs] = useState([]);
  const navigate = useNavigate();
  const wrapRef = useRef(null);

  const isAdmin = user.role === 'admin';

  useEffect(() => {
    const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) { setNotifOpen(false); setUserOpen(false); } };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  useEffect(() => {
    if (notifOpen) {
      notificationAPI.getRecent(6, isAdmin)
        .then((r) => setNotifs(r.data || []))
        .catch(() => setNotifs([]));
    }
  }, [notifOpen, isAdmin]);

  const flipTheme = () => { const next = toggleTheme(); setTheme(next); };

  const goProfile = () => { setUserOpen(false); navigate(getDashboardPath(user.permissions, user.role)); };

  const avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(user.username)}&background=037b90&color=fff&size=32`;

  return (
    <div className="topbar" ref={wrapRef}>
      <div className="topbar-search" onClick={onOpenSearch} role="button" tabIndex={0}>
        <Icon name="search" />
        <span className="ts-text">Search pages & actions…</span>
        <span className="ts-kbd">⌘K</span>
      </div>

      <div className="topbar-actions">
        <button className="icon-btn" onClick={flipTheme} title={theme === 'dark' ? 'Switch to light' : 'Switch to dark'}>
          <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
        </button>

        <div style={{ position: 'relative' }}>
          <button className="icon-btn" onClick={() => { setNotifOpen((o) => !o); setUserOpen(false); }} title="Notifications">
            <Icon name="bell" />
            <span className="badge-dot">●</span>
          </button>
          {notifOpen && (
            <div className="popover">
              <div className="popover-header"><h4>Notifications</h4></div>
              <div className="popover-body">
                {notifs.length === 0 && <div className="popover-empty">You're all caught up.</div>}
                {notifs.map((n, i) => (
                  <div key={n.id || i} className="notif-row">
                    <div>
                      <div className="nr-title">{n.title}</div>
                      {n.message && <div className="nr-msg">{n.message}</div>}
                      <div className="nr-time">{n.created_at ? new Date(n.created_at).toLocaleDateString() : ''}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="topbar-user" style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { setUserOpen((o) => !o); setNotifOpen(false); }}>
          <img src={avatar} alt={user.username} className="user-avatar-img" style={{ width: 34, height: 34, borderRadius: '50%' }} />
          <div>
            <div className="tu-name">{user.full_name || user.username}</div>
            <div className="tu-role">{user.role}</div>
          </div>
          <Icon name="chevron-down" />
          {userOpen && (
            <div className="popover" style={{ left: 0, right: 'auto', width: 200 }}>
              <button className="menu-item" onClick={goProfile}><Icon name="user" /> My Dashboard</button>
              <button className="menu-item" onClick={() => { setUserOpen(false); onLogout(); }}><Icon name="logout" /> Logout</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
